import { ReactElement } from 'react';

import { Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';

import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import styles from './_ShowMore.module.css';

type ShowMoreProps = {
	children: ReactElement;
	currentText: Field<string>;
	pageIndex: number;
	pageSize: number;
	totalResults: number;
};

export function ShowMore(props: ShowMoreProps): JSX.Element {
	const isEditing = IsSitecoreEditing();
	const isShowingAll = props.pageSize * props.pageIndex >= props.totalResults;
	const adjustedPageSize = isShowingAll ? props.totalResults : props.pageSize * props.pageIndex;

	if (!isEditing && !props.totalResults) {
		return <></>;
	}

	return (
		<div className={`${styles.showMore} padYL`}>
			{(isEditing || !isShowingAll) && props.children}

			<div className={styles.bar}>
				<span className={styles.progress} style={{ width: `${(adjustedPageSize / props.totalResults) * 100}%` }} />
			</div>

			<p className={styles.status}>
				<Text field={props.currentText} />
				<div translate="no">
					{adjustedPageSize}/{props.totalResults}
				</div>
			</p>
		</div>
	);
}
